import { Component, ChangeDetectionStrategy, AfterViewInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import {
  ConfirmByKeypressDirective,
  SkModalBase,
  SkModalContentComponent ,
  StrakitButtonPrefixDirective,
} from '@ngx-strakit/cdk';

@Component({
  selector: 'confirm-rename-file-modal',
  imports: [
    TranslatePipe,
    SkModalContentComponent,
    ConfirmByKeypressDirective,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './confirm-rename-file-modal.component.html',
  styleUrls: ['./confirm-rename-file-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisConfirmRenameFileModalComponent extends SkModalBase<IrisConfirmRenameFileModalComponent, boolean> implements AfterViewInit {
  readonly data = inject<{
    fileName: string;
    newFileName: string;
  }>(MAT_DIALOG_DATA);

  readonly fileName = this.data.fileName;
  readonly newFileName = this.data.newFileName;

  isInitCompleted = false;

  ngAfterViewInit(): void {
    this.isInitCompleted = true;
  }

  confirm(): void {
    this.closeWithResult(true);
  }
}
